export const getNavigationState = location => ({
    from: getNavigationPath(location),
})
export const getNavigationPath = location => `${location.pathname}${location.search || ''}`
